import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { connect } from "react-redux";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import { useToasts } from "react-toast-notifications";
import ImageUploader from "react-images-upload";
import { changeData, fetchAnagraficaWithResult, uploadFile } from "../../helpers/dbOperations";
import { Link } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { Box, Button, makeStyles, Paper, Tabs, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import { fetchAnagrafica, fetchSendCartData } from "../../helpers/dbOperations";
import CustomerModal from './modals/modalCustomer'
import { Modal } from "react-bootstrap";
import { Article } from "./animationList";
import ReactLoading from "react-loading";
import it from 'date-fns/locale/it';
import { format } from "date-fns";
import { Input, TextField } from "@mui/material";

const Ritiri = ({ location, userData, saveUser }) => {
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
    },
    mymodal: {
      width: '20vw',  /* Occupy the 90% of the screen width */
      maxWidth: '20vw'
    }
  });
  var strings = require("../../translations/italian.json");
  const [value, setValue] = React.useState(0);
  const classes = useStyles();
  const [date, setDate] = useState([])
  const [numSlot, setNumSlot] = useState(0)
  const [dateAbilitate, setDateAbilitate] = useState([])

  const [showModalCustomer, setShowModalCustomer] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [customerArray, setCustomerArray] = useState([]);
  const [onClick, setOnClick] = useState(0);
  const [idCli, setIdCli] = useState(0)
  const [inCaricamentoCheckOut, setinCaricamentoCheckOut] = useState(false);
  const [wait, setWait] = useState(false)
  
  var _sper = sessionStorage.getItem('personal');
  if (_sper === 'undefined') _sper = null;
  const personal = _sper ? JSON.parse(_sper) : {};

  const { addToast } = useToasts();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const SegliAnagrafica = (risultatoAnagrafica) => {
    setModalTitle("Scegli il cliente")
    risultatoAnagrafica.Anagrafica.map((item) => {
      item.value = item.RagSoc
      item.id = item.IdCli
      return item
    })
    setCustomerArray(risultatoAnagrafica.Anagrafica)
    setOnClick(1)
    setShowModalCustomer(true)

  }
  const caricaAnagrafica = async () => {
    //console.log("carica anagrafica")
    var username = userData.user.user.username;
    var password = userData.user.user.password;
    var indexAnagraficaScelta = 0;
    var indexSede = 0;
    var risultatoAnagrafica = {};
    fetchAnagraficaWithResult({ username, password }).then(res => res.json()).then(result => {
      //console.log(result)
      if ((!result) || (!result.Anagrafica)) return result;

      if (result.Anagrafica.length > 1) {
        indexAnagraficaScelta = SegliAnagrafica(result);
      }
      else {
        setIdCli(result.Anagrafica[0].IdCli)
        setCustomerArray(result.Anagrafica)
      }
      return result;
    })


  }


  useEffect(() => {


        var body = '';

        var endpoint = global.endpoint + "pegaso/getDateRitiroDisabilitate"
        fetch(endpoint, {
          method: "POST",
          headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
          body: body,
          withCredentials: false
        })
          .then((res) => res.json())
          .then(
            (result) => {
              setDate(result.Date)
              setNumSlot(result.NumSlot)
              setDateAbilitate(result.DateAbilitate)

            }
          )

  }, [])

  
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        style={{ width: "100%" }}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  function openWindowWithPost(url, data) {
    var form = document.createElement("form");
    form.target = "print_popup";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";
    form.onsubmit = "window.open('about:blank','print_popup','width=1000,height=800');"
    for (var key in data) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    //window.open(this.href, '_blank', 'width=300,height=200');
    document.body.removeChild(form);
  }
  return (
    <Fragment>
      <MetaTags>
        <title>{strings.my_account} | {strings.titleSite}</title>
        <meta
          name="description"
          content={strings.my_account + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb 
        <Breadcrumb />*/}


        <div className="login-register-area pt-100 pb-100" style={{background: "url(https://www.food-safety.com/ext/resources/fsm/cache/file/3B40D087-FDF9-43B7-9353CE2E6C9CC945.jpg?1611013847)", backgroundColor: "rgba(255,255,255,0.8)",
        backgroundBlendMode: "lighten"}}>
          <div className="container">
          {userData.user.user?.IDCli === 37548 && window['configPegaso'].utentiAbilitatiConfRitiro?.includes(localStorage.getItem("IDDetCliRef")) ?          <div className="row">
              <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
              />


              {/*personal.IDLis && <div style={{justifyContent:"center", display:"flex",width:"100%", marginBottom:"5%"}}>
                {personal.IDLis== 34 && <a href="/files/listino_4super.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                {personal.IDLis== 33 && <a href="/files/listino_5top.pdf" style={{padding:"1%", border:"1px dotted black"}}>Visualizza il tuo listino!</a>}
                </div>
        */}
 
              <AppBar position="static" color="default" style={{ zIndex: 1 }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  TabIndicatorProps={{ style: { background: 'gray' } }}
                >
                  <Tab label="Date disabilitate" style={{ minWidth: "50%" }} />
                  <Tab label="Slot" style={{ minWidth: "50%" }} />
                </Tabs>
              </AppBar>
              <TabPanel value={value} index={0}>
                <div style={{}}>
                  <MaterialTable
                  editable={{
                    onRowDelete: oldData =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            const dataDelete = [...date];
                            const index = oldData.tableData.id;
                            dataDelete.splice(index, 1);
                            setDate([...dataDelete]);
                            var endpoint = global.endpoint + "pegaso/deleteDataRitiroDisabilitata"

                            var body = '{data:"'+oldData.DataRitiroDisabilitata+'"}';
                            fetch(endpoint, {
                                method: "POST",
                                headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
                                body: body,
                                withCredentials: false
                                })
                                .then((res) => res.json())
                                .then(
                                    (result) => {
                                        if(result.Errore != "") addToast(result.Errore, {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
                                        else addToast("Data cancellata con successo", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
                                    //setDate(result.Date)
                                    }
                                )
                            resolve();
                        }, 1000);
                    }),
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                setDate([...date, newData]);
                                var body = '{data:"'+format(newData.DataRitiroDisabilitata, "MM-dd-yyyy")+'"}';
        
                                var endpoint = global.endpoint + "pegaso/insertDataRitiroDisabilitata"
                                fetch(endpoint, {
                                method: "POST",
                                headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
                                body: body,
                                withCredentials: false
                                })
                                .then((res) => res.json())
                                .then(
                                    (result) => {
                                        if(result.Errore != "") addToast(result.Errore, {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
                                        else addToast("Data aggiunta con successo", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
                                    }
                                )

                                resolve();
                            }, 1000);
                        }),
                  }}
                   
                    localization={{
                      pagination: {
                        labelDisplayedRows: '{from}-{to} di {count}',
                        labelRowsPerPage: '{25,100}',
                        labelRowsSelect: 'righe'
                      },
                      toolbar: {
                        nRowsSelected: '{0} riga(e) selezionate',
                        searchTooltip: "Ricerca",
                        searchPlaceholder: "Ricerca"
                      },
                      header: {
                        actions: 'Azioni'
                      },
                      body: {
                        emptyDataSourceMessage: 'Nessuna data da visualizzare',
                        filterRow: {
                          filterTooltip: 'Filtro'
                        },
                        dateTimePickerLocalization: it,
                        editRow:{
                            deleteText:"Sei sicuro di cancellare questa data?"
                        } 

                      }
                    }}
                    style={{ width: "1200" }}
                    columns={[
                      { title: "Data", field: "DataRitiroDisabilitata", type: "date", dateSetting: { locale: "it-IT"} },
                     
                    ]}
                    data={JSON.parse(
                      JSON.stringify(
                        date
                      )
                    )
                    }
                    title="Date ritiro disabilitate"
                    options={{
                      pageSize: 10,
                      actionsColumnIndex: -1

                    }}
                  />
                </div>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <div style={{backgroundColor:"white", padding:"50px"}}>
                <TextField
                    key="numSlot"
                    id="outlined-read-only-input"
                    value={numSlot}
                    onChange={(e)=> setNumSlot(e.target.value)}
                    autoFocus
                    />
                    <Button variant="contained" onClick={()=> {
                        var body = '{numSlot:'+numSlot+'}';
        
                        var endpoint = global.endpoint + "pegaso/changeSlotNumber"
                        fetch(endpoint, {
                        method: "POST",
                        headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
                        body: body,
                        withCredentials: false
                        })
                        .then((res) => res.json())
                        .then(
                            (result) => {
                                if(result.Errore != "") addToast(result.Errore, {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
                                else addToast("Numero di slot cambiati con successo", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
                            //setDate(result.Date)
                            }
                        )

                    }}>Cambia</Button>
                    <p><b>ATTENZIONE!!</b> Il cambiamento ha effetto solo quando si clicca sul pulsante <b>Cambia</b></p>
                    <MaterialTable
                  editable={{
                    onRowDelete: oldData =>
                    new Promise((resolve, reject) => {
                        setTimeout(() => {
                            const dataDelete = [...dateAbilitate];
                            const index = oldData.tableData.id;
                            dataDelete.splice(index, 1);
                            setDateAbilitate([...dataDelete]);
                            var endpoint = global.endpoint + "pegaso/deleteDataRitiroAbilitata"

                            var body = '{data:"'+oldData.Data+'"}';
                            fetch(endpoint, {
                                method: "POST",
                                headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
                                body: body,
                                withCredentials: false
                                })
                                .then((res) => res.json())
                                .then(
                                    (result) => {
                                        if(result.Errore != "") addToast(result.Errore, {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
                                        else addToast("Data cancellata con successo", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
                                    //setDate(result.Date)
                                    }
                                )
                            resolve();
                        }, 1000);
                    }),
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            setTimeout(() => {
                                setDateAbilitate([...dateAbilitate, newData]);
                                var body = '{data:"'+format(newData.Data, "MM-dd-yyyy")+'",numRit:'+newData.NumRit+'}';
        
                                var endpoint = global.endpoint + "pegaso/insertDataRitiroAbilitate"
                                fetch(endpoint, {
                                method: "POST",
                                headers: new Headers({ "Content-Type": "application/x-www-form-urlencoded", }),
                                body: body,
                                withCredentials: false
                                })
                                .then((res) => res.json())
                                .then(
                                    (result) => {
                                        if(result.Errore != "") addToast(result.Errore, {appearance: "error", autoDismiss: true, placement: 'bottom-left' });
                                        else addToast("Data aggiunta con successo", {appearance: "success", autoDismiss: true, placement: 'bottom-left' });
                                    }
                                )

                                resolve();
                            }, 1000);
                        }),
                  }}
                   
                    localization={{
                      pagination: {
                        labelDisplayedRows: '{from}-{to} di {count}',
                        labelRowsPerPage: '{25,100}',
                        labelRowsSelect: 'righe'
                      },
                      toolbar: {
                        nRowsSelected: '{0} riga(e) selezionate',
                        searchTooltip: "Ricerca",
                        searchPlaceholder: "Ricerca"
                      },
                      header: {
                        actions: 'Azioni'
                      },
                      body: {
                        emptyDataSourceMessage: 'Nessuna data da visualizzare',
                        filterRow: {
                          filterTooltip: 'Filtro'
                        },
                        dateTimePickerLocalization: it,
                        editRow:{
                            deleteText:"Sei sicuro di cancellare questa data?"
                        } 

                      }
                    }}
                    style={{ width: "1200" }}
                    columns={[
                      { title: "Data", field: "Data", type: "date", dateSetting: { locale: "it-IT"} },
                      { title: "#ritiri", field: "NumRit", type: "numeric" },
                    ]}
                    data={JSON.parse(
                      JSON.stringify(
                        dateAbilitate
                      )
                    )
                    }
                    title="Date ritiro speciali"
                    options={{
                      pageSize: 10,
                      actionsColumnIndex: -1

                    }}
                  />
                </div>
              </TabPanel>

            </div>:<h1 style={{textAlign:"center"}}>UTENTE NON ABILITATO!</h1>}
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

Ritiri.propTypes = {
  location: PropTypes.object,
  userData: PropTypes.object,
  cartData: PropTypes.array,
  compareData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func,
  wishlistData: PropTypes.array,
  setToken: PropTypes.func
};

const mapStateToProps = state => {
  return {
    userData: state.userData ? state.userData : []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    saveUser: (user, addToast) => { dispatch(saveUser(user, addToast)) }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Ritiri);

